const RealestateBenefit = ({ data, showIndex, handleShow }) => {
  return (
    <div className={`rs-ben-wrap ${showIndex ? "rs-ben-bor" : ""}`}>
      <div className="rs-ben-wrap-left" onClick={handleShow}>
        <div className="rs-ben-flex">
          <img
            src={data.img}
            alt="Real estate tokenization"
            className={`rs-ben-right-img ${showIndex ? "rs-ben-bor" : ""}`}
          />
          <h5 className="rs-ben-right-title">{data.title}</h5>
        </div>
        <div className="rs-ben-arrow">
          {showIndex ? (
            <i className="fa-solid fa-arrow-up"></i>
          ) : (
            <i className="fa-solid fa-arrow-down"></i>
          )}
        </div>
      </div>

      <div className={`rs-ben-right-content ${showIndex ? "show" : ""}`}>
        <p className="rs-ben-right-para">{data.content}</p>
      </div>
    </div>
  );
};

export default RealestateBenefit;
